import App from './App';
import View from './View';
import * as body from './body';
import * as layout from './layout';
import * as widgets from './widgets';

export {
    App,
    View,
    body,
    layout,
    widgets
};



// WEBPACK FOOTER //
// ./src/views/index.js